import Vue from 'vue'
import App from './App.vue'
import router from './router'

Vue.config.productionTip = false
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'

// import App from './App.vue';
// 引入axios
import axios from 'axios'
// 将axios挂载到vue的原型上,这样每个页面都可以用了
Vue.prototype.$axios = axios
Vue.use(ElementUI)
new Vue({
  router,
  render: (h) => h(App)
}).$mount('#app')
// router.beforeEach((to, from, next) => {
//   console.log(to, from)
//   let joinId = sessionStorage.getItem('joinId')
//   if (joinId) {
//     next()
//   } else {
//     next({ path: '/' })
//   }
// })
